export default __webpack_public_path__ + "static/media/10.cf0b00b8.svg";